import type { CSSProperties } from 'react';
import type { SxProps, Theme } from '@mui/material/styles';

type AppLayoutStyleMap = {
    root: SxProps<Theme>
    appBar: SxProps<Theme>
    toolbar: SxProps<Theme>
    logoLink: SxProps<Theme>
    logoIcon: SxProps<Theme>
    desktopRightSection: SxProps<Theme>
    notificationsPopoverPaper: SxProps<Theme>
    notificationsHeader: SxProps<Theme>
    notificationsContent: SxProps<Theme>
    notificationsFooter: SxProps<Theme>
    profileTrigger: SxProps<Theme>
    profileTextWrapper: SxProps<Theme>
    profileAvatar: SxProps<Theme>
    logoutMenuItem: SxProps<Theme>
    mobileMenuButton: SxProps<Theme>
    desktopTabsWrapper: SxProps<Theme>
    desktopTabs: SxProps<Theme>
    desktopTabLabel: SxProps<Theme>
    mobileDrawer: SxProps<Theme>
    mobileDrawerUserRow: SxProps<Theme>
    mobileDrawerAvatar: SxProps<Theme>
    mainContent: SxProps<Theme>
    footer: SxProps<Theme>
    footerContainer: SxProps<Theme>
};

export const appLayoutStyles: AppLayoutStyleMap = {
    root: { minHeight: '100vh', bgcolor: 'grey.50', display: 'flex', flexDirection: 'column' },
    appBar: { bgcolor: 'background.paper', color: 'text.primary', zIndex: (theme) => theme.zIndex.drawer + 1 },
    toolbar: { justifyContent: 'space-between', px: { xs: 2, sm: 3 } },
    logoLink: { display: 'flex', alignItems: 'center', textDecoration: 'none' },
    logoIcon: { width: 32, height: 32, bgcolor: 'primary.main', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', mr: 1 },
    desktopRightSection: { display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 2 },
    notificationsPopoverPaper: { width: 380, maxHeight: 480, display: 'flex', flexDirection: 'column' },
    notificationsHeader: { px: 2, py: 1.5, borderBottom: '1px solid', borderColor: 'divider' },
    notificationsContent: { flex: 1, overflowY: 'auto' },
    notificationsFooter: { p: 1 },
    profileTrigger: { display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' },
    profileTextWrapper: { textAlign: 'right', display: { xs: 'none', lg: 'block' } },
    profileAvatar: { width: 36, height: 36, bgcolor: 'primary.light', fontSize: 14, fontWeight: 700 },
    logoutMenuItem: { color: 'error.main' },
    mobileMenuButton: { display: { md: 'none' } },
    desktopTabsWrapper: { display: { xs: 'none', md: 'block' }, bgcolor: 'background.paper', borderTop: '1px solid', borderColor: 'divider' },
    desktopTabs: { px: { sm: 3 }, minHeight: 48 },
    desktopTabLabel: { display: 'flex', alignItems: 'center', gap: 0.75 },
    mobileDrawer: { width: 280, pt: 2 },
    mobileDrawerUserRow: { px: 2, pb: 2, display: 'flex', alignItems: 'center', gap: 1 },
    mobileDrawerAvatar: { bgcolor: 'primary.light', fontWeight: 700 },
    mainContent: { py: 4, px: { xs: 2, sm: 3 }, flex: 1 },
    footer: { borderTop: '1px solid', borderColor: 'divider', bgcolor: 'background.paper', py: 2 },
    footerContainer: { px: { xs: 2, sm: 3 } },
};

export const getAppLayoutDesktopTabStyles = (isActive: boolean): SxProps<Theme> => ({
    minHeight: 48,
    textTransform: 'none',
    fontWeight: isActive ? 600 : 400,
    color: isActive ? 'primary.main' : 'text.secondary',
    fontSize: 14,
});

export const getAppTabIndicatorStyle = (theme: Theme): CSSProperties => ({
    backgroundColor: theme.palette.primary.main,
});

export const appLayoutMenuIconStyles: CSSProperties = {
    marginRight: 8,
};
